export default __webpack_public_path__ + "static/media/fingertips.97b792a6.svg";